module.exports = __webpack_public_path__ + "static/media/img-class-empty.1bb756f9.svg";